export default "/images/phone-home.svg?65affbc20548e090f10203e5be8ac354";